// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__8JyCh","container":"styles_container__1e3iC","title":"styles_title__vsKZ7","wrapper":"styles_wrapper__1x9GL","answer":"styles_answer__37unJ"};